import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { CalculationSpec } from '../../../../../../../../types/Quotes';
import useQuoteSpecs from '../../../store/offer/useQuoteSpecs';
import OfferParameterSpec from '../offer-actions/parameters/OfferParameterSpec';

interface Props {
  calcSpec: CalculationSpec;
  paymentInterval?: string;
}

const OfferPaymentIntervalSelect: React.FC<Props> = ({
  calcSpec,
  paymentInterval,
}) => {
  const { quoteSpecs, setQuoteSpecs } = useQuoteSpecs();
  const methods = useForm({
    values: {
      PAYMENT_INTERVAL: paymentInterval,
    },
  });
  const selectedInterval = methods.watch('PAYMENT_INTERVAL');

  const handleSubmit = methods.handleSubmit((vals) => {
    const newQuoteSpecs = {
      ...quoteSpecs,
      [calcSpec.specs_field]: vals.PAYMENT_INTERVAL,
    };
    setQuoteSpecs(newQuoteSpecs);
  });

  useEffect(() => {
    if (methods.formState.isValid && selectedInterval !== paymentInterval) {
      handleSubmit();
    }
  }, [selectedInterval]);

  return (
    <FormProvider {...methods}>
      <OfferParameterSpec calcSpec={calcSpec} />
    </FormProvider>
  );
};

export default OfferPaymentIntervalSelect;
